import { Button } from '@mui/material';
import styled from 'styled-components';
import { colors } from '../../../utils';

const { colorPrimary, colorWhite, colorGradient } = colors;

export const Btn = styled(Button)`
	// background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : `${colorPrimary} !important`)};
	// background: ${colorGradient};
	background: ${({ backgroundColor }) => backgroundColor || colorGradient};
	color: ${(props) => (props.color ? props.color : `${colorWhite} !important`)};
	font-size: 1.4rem !important;
	text-transform: none !important;
	padding: 1rem 3rem !important;
	border-radius: 0.5rem !important;
transition: transform 0.3s ease, box-shadow 0.3s ease;
  
	&:hover {
			transform: scale(1.05);
	}
	&:disabled {
		opacity: 0.8 !important;
	}
`;
